export const dateTypeMappings = {
  'engagementDate': 'Engagement',
  'OnboardedDate': 'Onboarded'
}

export const onboardOptions = [
  { value: 1, label: 'Fully Onboarded' },
  { value: 2, label: 'Not Onboarded' }
]

export const inNotInOptions = [
  { id: 2, label: 'IN' },
  { id: 3, label: 'NOT IN' }
]

export const referralOptions = [
  { value: '', label: 'Any' },
  { value: 1, label: 'Include users having referral' },
  { value: 2, label: 'Include users who have not received a referral' }
]

export const equalNotEqualOptions = [
  { id: 4, label: 'EQUALS' },
  { id: 5, label: 'NOT EQUALS' }
]

export const languages = [
  { label: 'English', id: 'eng' },
  { label: 'Swahili', id: 'swa' },
  { label: 'Hindi', id: 'hi' },
  { label: 'Marathi', id: 'mar' },
  { label: 'Hausa', id: 'hau' },
  { label: 'Gujarati', id: 'guj' },
  { label: 'Tamil', id: 'tam' },
  { label: 'Odia', id: 'odi' },
  { label: 'Assamese', id: 'asm' },
  { label: 'Kannada', id: 'kan' },
  { label: 'Telugu', id: 'tel' },
  { label: 'Thai', id: 'tha' },
  { label: 'Indonesian', id: 'ind' }
]

export const reminderOptions = [
 { value: '', label: 'Any' },
 { value: 1, label: 'Future scheduled Reminders' }, // includes only those users for whom we have scheduled reminders for future
 { value: 2, label: 'No future scheduled Reminders' } // includes only those users for whom we have not scheduled any reminders for future
]



// WEBPACK FOOTER //
// ./src/components/audience-builder/constants.js